import { render } from "./HomeCategoryList.vue?vue&type=template&id=d8febacc"
import script from "./HomeCategoryList.vue?vue&type=script&lang=js"
export * from "./HomeCategoryList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mli\\JTX\\ichioshiSS\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__